<template>
	<AppSection :number="step" title="Add text">
		<AppInput
			:class="{ 'form-error': validation.product.title.$error }"
			class="form-group mb-3 pb-2"
			label="Title"
			dataTestId="title"
			maxlength="50"
			placeholder="Title Here..."
			v-model="value.product.title"
			required=""
		/>

		<div class="layout-callout-preview" v-if="['callout', 'preview'].includes(value.button.layout)">
			<div>
				<AppInput
					class="form-group mb-3 pb-2"
					label="Subtitle"
					dataTestId="subtitle"
					maxlength="100"
					placeholder="Enter a description for your followers here"
					v-model="value.button.tagline"
				/>
			</div>
			<AppInput
				class="form-group mb-0"
				:class="{ 'form-error': validation.button.button_text.$error }"
				label="Button*"
				dataTestId="button-text"
				:key="value.button.layout"
				maxlength="30"
				placeholder="Button Text Here..."
				v-model="value.button.button_text"
			/>
		</div>
	</AppSection>
</template>
<script>
	export default {
		props: {
			step: {
				type: String,
				required: true,
			},
			value: {
				type: Object,
				default: () => {},
			},
			validation: {
				type: Object,
				default: () => {},
			},
		},
	}
</script>
<style lang="scss"></style>
